import { Tooltip } from "@mui/material"
import mIcon from '../img/maps.svg';
import previous from '../img/previous.png';
import next from '../img/next.png';
import { useEffect, useState } from "react";
import ConnectionFinder from "../api/ConnectionFinder";
const FibreCoveredList = ({Data}) => {
    const [page,setpage] = useState([])
    const [num_page,setnum_page] = useState(0)
    const [new_fetch, setnew_fetch] = useState([])
    const [maxpage,setmaxpage] = useState(Math.trunc(Data.length / 25))
    const isCity = Data.length > 1

    //Correggere fa crashare se si cerca comune coperto da FibreConenct
    
    const SearchForCivics = async() =>{
        //Se la lunghezza dei dati è maggiore di 1 significa che la ricerca è stata fattua sulla citta
        //Quindi abbiamo già i dati e dobbiamo solo caricarli in tabella
        if (isCity) {
            Impaginate(true,true)
            return
        }
        const resp = await ConnectionFinder.get("/FibregetNearList",{
            params:{
                Citta: Data.Citta,
                Indirizzo: Data.Indirizzo,
                Numero_Civico: Data.Numero_Civico
            }
        })
        setmaxpage(Math.trunc(resp.data.details.length / 25))
        if (resp.data.details.length % 25 !== 0 && resp.data.details.length > 25) setmaxpage(Math.trunc(resp.data.details.length / 25)+ 1)
        setnew_fetch(resp.data.details)
        Impaginate(true,true,resp.data.details)
        return resp.data.details
    }
    const Impaginate = (next, isFirstLoad, State_Not_Loaded) =>{
        let num_page_local
        next ? num_page_local = num_page + 1 : num_page_local = num_page - 1; 
        if (isFirstLoad) num_page_local = 0
        setnum_page(num_page_local)
        if (num_page_local < 0) return
        const results_page = []
        //Dichiaro una variabile che conterrà i valori da iterare
        let LocalData
        //Ovvero, se la ricerca è città allora i dati passati a questo componente, altrimenti i dati appena fetchati
        isCity ? LocalData = Data : LocalData = new_fetch;
        if (LocalData.length === 0 & !isCity)
            LocalData = State_Not_Loaded
        if (!Array.isArray(LocalData)) LocalData = [LocalData]
        for (let i = num_page_local * 25; i < (num_page_local + 1) * 25; i++){
            if (!LocalData[i]) continue
            results_page.push(LocalData[i])
        }
        setpage(results_page)
    }
    useEffect(()=>{
        // console.log("So useEffect")
        if (Data.length % 25 !== 0 && Data.length > 25 && isCity) setmaxpage(Math.trunc(Data.length / 25)+ 1)
        SearchForCivics(false)
    //TODO Rimuovere questo warning con useCallback
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])
    return(
    <div className="coveredListContainer" style={{marginBottom: '3%'}}>
        <div className="coveredListTitle">
            <p className='clText'>Altri civici</p>
        </div>
        <ul className="coveredListContainerScroll">
            {
                page.map((item) => {
                let sColor = '#2ECC71'
                let sText = 'Connesso'
                    return(
                        <li className="coverItem" key={item.Id}>
                            <div className="coverItemDatas" >
                                <span style={{cursor: 'pointer'}}>
                                    {item.Indirizzo} {item.Numero_Civico}
                                </span>
                                <Tooltip  title={sText}>
                                    <span style={{backgroundColor: sColor, color: 'white', padding: '5px', paddingTop: '1px', paddingBottom: '1px', borderRadius: '5px', marginLeft: '5px', fontSize: '20px'}} >{"Connesso"}</span>
                                </Tooltip >
                            </div>
                            <a className="coverItemLocation" target="_blank" rel="noopener noreferrer" href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(item.plusCODE) }`}>
                                <img src={mIcon} alt=""  width="30px" height="30px"/>
                            </a>                                                
                        </li>
                    )
                }
            )}
        </ul>
        <div style={{widht: '100%', display: 'flex', height: '60px', justifyContent: 'space-between'}}>
            {num_page !== 0 && <div onClick={() => Impaginate(false,false)} style={{width: '40%', backgroundColor: '#ff0f64', color: 'white', height: '10px' ,borderRadius: '13px', transform: 'none',margin: 'auto', marginLeft: '2%'}} className="rButton">
                <img src={previous} alt="" width={'25px'} height={'25px'} />
            </div> }  
            {num_page < maxpage - 1 && maxpage > 1 && <div onClick={() => Impaginate(true,false)} style={{width: '40%', backgroundColor: '#ff0f64', color: 'white', height: '10px' ,borderRadius: '13px', margin: 'auto',marginRight: '2%', transform: 'none'}} className="rButton">
                <img src={next} alt="" width={'25px'} height={'25px'}/>
            </div>}
        </div>
    </div>  
        
    )
}
export  default FibreCoveredList